/* eslint-disable no-unused-vars */
import Signal from 'libs/signals';

const loaderSignal = Signal({ isContentLoading: false, other: 'thing', isSigningOut: false, });

export default loaderSignal;
